import { MonthlyUsageStore } from '../stores/monthlyUsage';
import { IBodyItemResponse, IRequestRelationshipMainItem, apiManager } from '../REST';
import {
    IBodyListResponse,
    IIncludeUserItemAPI,
    IInvoiceTotal,
    IMonthlyInvoices,
    IParamsList,
    IReportsList,
    IReportsListAPI,
    IReportsListItemAPI,
} from '../interfaces';
import { dateText2Utc, mapApi2UiField } from '../instruments';

export function cleanMonthlyUsageStore(): void {
    const StoreInstance = MonthlyUsageStore.getInstance();
    StoreInstance.cleanStore();
}

export function formatMonthlyUsageList(apiUsers: IReportsListAPI): IReportsList[] {
    const users: IIncludeUserItemAPI[] =
        apiUsers?.included?.filter((i: IRequestRelationshipMainItem) => i.type === 'user') || [];

    return apiUsers?.data?.map((report: IReportsListItemAPI) => {
        const attributes = mapApi2UiField(report.attributes || {});
        const createdAt = dateText2Utc(attributes.createdAt);
        delete attributes.payload;
        const payload = mapApi2UiField(report.attributes?.payload || {});
        const userId = report.relationships?.user?.data?.id;
        const user = mapApi2UiField(users.find((u: IRequestRelationshipMainItem) => u.id === userId)?.attributes || {});
        return {
            id: report.id,
            ...attributes,
            createdAt,
            ...payload,
            userId,
            ...user,
        };
    }) as IReportsList[];
}

export function setMonthlyUsageList(apiData: IReportsListAPI): void {
    const StoreInstance = MonthlyUsageStore.getInstance();
    StoreInstance.setList(formatMonthlyUsageList(apiData as IReportsListAPI));
}

export async function getMonthlyUsageList(params: IParamsList): Promise<IBodyItemResponse | IBodyListResponse> {
    const { resp } = await apiManager.getApi('GET_MONTHLY_USAGE_REPORTS', { searchParamsList: params });

    return resp;
}

export function setMonthlyUsageTotalList(total: { [key: string]: string }): void {
    const StoreInstance = MonthlyUsageStore.getInstance();
    StoreInstance.setTotal(total);
}

export async function getInvoicesMonthlyTotal(): Promise<any | void> {
    const { resp } = await apiManager.getApi('GET_INVOICES_MONTHLY_TOTALS');
    const { totals } = resp as IInvoiceTotal;

    const formattedTotals: any = {};

    Object.entries(totals).forEach((item: any) => {
        const key = item[0].split(' ')[0];

        formattedTotals[key] = item[1];
    });

    setMonthlyUsageTotalList(formattedTotals);
}

export async function getMonthlyInvoices(params: IParamsList): Promise<IMonthlyInvoices[]> {
    const { resp } = await apiManager.getApi('GET_MONTHLY_USAGE_INVOICES', { searchParamsList: params });

    const { invoices = {} } = resp as IBodyListResponse;

    return invoices as IMonthlyInvoices[];
}

export function setMonthlyUsageForcedUpdateTime(): void {
    const StoreInterface = MonthlyUsageStore.getInstance();
    StoreInterface.setForcedUpdateTime();
}
